import { Component, HostListener, Inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { log } from 'node:console';
import { AppConfigService } from '../../../services/config/app-config.service';
import { SatesListService } from '../../../services/raintree/Transmission/sates-list.service';
import { DistrictListService } from '../../../services/raintree/Transmission/district-list.service';
import { LoaderComponent } from '../../../common-component/loader/loader.component';

@Component({
  selector: 'app-mandir-bill-filter',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatIconModule,
    MatSelectModule,
    FormsModule,
    LoaderComponent,
  ],
  templateUrl: './mandir-bill-filter.component.html',
  styleUrls: [
    './mandir-bill-filter.component.scss',
    '../../../../styles/_dropdown.scss',
  ],
})
export class MandirBillFilterComponent {
  FILTERS: any = {
    fy: 0,
    addr: 1,
  };

  filterOptions: any[] = [
    {
      title: 'Financial Year',
      id: 'fy',
    },
    {
      title: 'Address',
      id: 'addr',
    },
  ];

  FY = [
    { key: '2026', value: '2026-2025' },
    { key: '2025', value: '2025-2024' },
    { key: '2024', value: '2024-2023' },
    { key: '2023', value: '2023-2022' },
    { key: '2022', value: '2022-2021' },
    { key: '2021', value: '2021-2020' },
  ];

  // FY: { key: string, value: string }[]=[];
  selectedFY = new FormControl('');
  States: any[] = [];
  seletedState = new FormControl('');
  // districts: any[] = [];
  dropDownDist:any[]=[]
  selectedDist = new FormControl('');
  allPerm: Record<string, any> = {};
  isLoading: boolean = false;
  selectedFilterIndex: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<MandirBillFilterComponent>,
    private _appConfig: AppConfigService,
    public stateTransmissionService: SatesListService,
    public districtTransmissionService: DistrictListService,
  ) {
    if (data) {
      const fy = data.fy;
      const dist = data.district;
      const state = data.state;
      this.selectedFY.setValue(fy);
      this.selectedDist.setValue(dist);
      this.seletedState.setValue(state);
    }
  }

  ngOnInit() {
    this.allPerm = this._appConfig.fetchPermissionv3ByViewName();

    this.getStateList();

    // this.FY = this.generateFYList(10)
    if(this.data.district && this.data.isAllDistrict){
      this.getDistrictList(this.data.state)
    }else{
      this.selectedDist.setValue(this.dropDownDist[0])
    }
    console.log(this.data, this.dropDownDist, 'filterData');
  }

  getStatesDistrictList() {
    this.isLoading = true;
    this.stateTransmissionService.getStatesList().subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (!response.error) {
          let resp = response.data;
          // console.log("getStatesDistrictList:response",resp)
          resp.forEach((elm: any) => {
            this.States.push(elm.stateName);
          });
          console.log('STates:', this.States);
        }
      },
      error: (error) => {
        console.log('error message for get state', error.message);
        this.isLoading = false;
      },
    });
  }

  getDistrictList(event: any) {
    this.isLoading = true;
    this.districtTransmissionService.getDistrictList(event).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (!response.error) {
          let resp = response.data;
          this.dropDownDist = [];
          resp.forEach((elm: any) => {
            this.dropDownDist.push(elm.district_name);
          });
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.log('error message for get district', error.message);
      },
    });
  }

  getStateList() {
    // this.calcObj()
    const countryPerm = this.allPerm['INDIA'];
    console.log(countryPerm);
    
    if (countryPerm.allStatesPerm.length > 0) {
      this.getStatesDistrictList();
    } else {
      const statePerm = Object.keys(countryPerm.statePerms)
      this.States = [...statePerm]  
      const distPerm = Object.keys(countryPerm.statePerms[this.States[0]].districtPerms)
      this.dropDownDist.push(distPerm);
      if(this.States.length === 1){
         this.seletedState.setValue(this.States[0]);
         if (this.dropDownDist.length === 1) {
              this.selectedDist.setValue(this.dropDownDist[0]);
          }
         
      }else{
        this.seletedState.setValue(this.States[0]);
        if (this.dropDownDist.length === 1) {
              this.selectedDist.setValue(this.dropDownDist[0]);
          }
      }    

    }
  }


  generateFYList(years: number = 6) {
    const currentYear = new Date().getFullYear();
    const fyList = [];

    for (let i = 0; i < years; i++) {
      const y1 = currentYear - i;
      const y2 = y1 - 1;

      fyList.push({
        key: y1.toString(),
        value: `${y1}-${y2}`,
      });
    }

    return fyList;
  }

  onFYChange() {}
  
  onStateChange(event: any) {
    const countryPerm = this.allPerm['INDIA']
    if(countryPerm.allStatesPerm.length === 0){
    const stateObj = countryPerm.statePerms
    console.log(stateObj);
    
    const districtObj = Object.keys(stateObj[event].districtPerms)
    console.log(districtObj, 'dis');

    this.dropDownDist = [...districtObj] 
    }else{
      this.getDistrictList(event)
    }      
  }

  onDistChange() {}

  closeDialog() {
    this.dialogRef.close();
  }

  applyFilter() {
    this.dialogRef.close({
      financeYear: this.selectedFY.value,
      state: this.seletedState.value,
      district: this.selectedDist.value,
      isAllDistrict: this.dropDownDist.length > 1 ? true : false
    });
  }

  resetFilter() {     
    if (this.States.length > 1 || this.dropDownDist.length > 1) {
      this.selectedDist.setValue('');
      this.seletedState.setValue('');
    }
    this.selectedFY.setValue('');
  }

  selectFilterItem(i: number) {
    this.selectedFilterIndex = i;
  }
}
